/**
 * TankInfo Service Layer
 *
 * API 호출 + Domain 변환을 담당
 * Layer Architecture 패턴 적용
 */

import type { TankInfo, TankInfoCardValues } from '../../types/domain/tankInfo'
import { toDomainTankInfo, toCardValues } from '../../types/mappers/tankInfo.mapper'
import { getTankInformation as getTankInformationApi } from './cardContainer'

/**
 * Tank 정보 조회 (Domain 모델 반환)
 *
 * @param tankId Tank ID
 * @returns TankInfo Domain 모델
 */
export async function fetchTankInfo(tankId: string): Promise<TankInfo> {
  const apiResponse = await getTankInformationApi(tankId)
  return toDomainTankInfo(apiResponse)
}

/**
 * Tank 정보 조회 + 카드 표시용 값 변환
 *
 * @param tankId Tank ID
 * @returns 카드 표시용 값들
 */
export async function fetchTankInfoCardValues(tankId: string): Promise<TankInfoCardValues> {
  const tankInfo = await fetchTankInfo(tankId)
  return toCardValues(tankInfo)
}
